import script from "./view-home.vue?vue&type=script&setup=true&lang=js"
export * from "./view-home.vue?vue&type=script&setup=true&lang=js"

import "./view-home.vue?vue&type=style&index=0&id=61e2b6e9&scoped=true&lang=css"

import exportComponent from "C:\\FileServer\\vedwen\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e2b6e9"]])

export default __exports__